/**
 * #1383 — adónde se manda a quien ya paga por Stripe.
 *
 * `/settings` es UNA página larga (Integraciones, Seguridad, Facturación…), sin
 * pestañas: un `?tab=` no haría nada. El ancla la resuelve `BillingSettings`,
 * que se desplaza a sí misma al cargar cuando la URL trae `#billing`.
 *
 * El doble cobro no lo impide esta ruta sino el backend (409 `use_change_plan`
 * en `POST /api/billing/checkout-session`); esto solo evita mandar al usuario a
 * un botón que le respondería con ese 409.
 */
export const BILLING_SECTION_ID = 'billing';
export const BILLING_SETTINGS_PATH = `/settings#${BILLING_SECTION_ID}`;

/**
 * #759 C: Facturación con el diálogo de cambio de plan abierto en `planId` (lo abre BillingSettings al
 * cargar, si ese plan se puede elegir). Lo usan el modal de agotado y el aviso del umbral.
 */
export const changePlanPath = (planId) => `/settings?change_plan=${encodeURIComponent(planId)}#${BILLING_SECTION_ID}`;
